import { ContactCollectionSection } from '#app/routes/mocra+/_form+/adverse-events/components/adverse-event-contacts-section.tsx'
import { type AdverseEventContactEntry } from '#app/routes/mocra+/_form+/adverse-events/form.ts'
import {
	type ContactCandidate,
	type ContactDraft,
} from '#app/routes/mocra+/_form+/components/contacts/types.ts'
import { type EntityCollectionItem } from '#app/routes/mocra+/_form+/entity-definition.ts'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly items: readonly EntityCollectionItem<
		AdverseEventContactEntry,
		ContactDraft
	>[]
	readonly onAdd: (draft: ContactDraft) => void
	readonly onEdit: (index: number, draft: ContactDraft) => void
	readonly onRemove: (index: number) => void
	readonly listErrors: readonly string[]
	readonly candidates?: readonly ContactCandidate[]
	readonly resources?: SectionResources
}

export function MedicalReviewersSection({
	items,
	onAdd,
	onEdit,
	onRemove,
	listErrors,
	candidates,
	resources,
}: Props) {
	return (
		<ContactCollectionSection
			title="Medical reviewers"
			description="Identify the clinicians or advisors who judge severity and timing for FDA submissions."
			emptyState="Add the clinicians or services who supply medical review."
			defaultRole="Medical reviewer"
			directorySource="Medical reviewers"
			items={items}
			onAdd={onAdd}
			onEdit={onEdit}
			onRemove={onRemove}
			listErrors={listErrors}
			candidates={candidates}
			resources={resources}
		/>
	)
}
